import Code, { Categories } from "app/models/code"

export enum Types {
  GET_BY_CATEGORY = "CODES_GET_BY_CATEGORY",
  GET_BY_CATEGORY_SUCCESS = "CODES_GET_BY_CATEGORY_SUCCESS",
  GET_BY_CATEGORY_FAIL = "CODES_GET_BY_CATEGORY_FAIL",
}

export type Action = GetCodesByCategoryAction | GetCodesByCategorySuccessAction | GetCodesByCategoryFailAction

export type GetCodesByCategoryAction = {
  payload: { category: Categories; disabled?: boolean }
  type: Types.GET_BY_CATEGORY
}

export type GetCodesByCategorySuccessAction = {
  payload: { category: Categories; data: Code[] }
  type: Types.GET_BY_CATEGORY_SUCCESS
}

export type GetCodesByCategoryFailAction = {
  payload: { errors: object }
  type: Types.GET_BY_CATEGORY_FAIL
}

export function getCodesByCategory(category: Categories, disabled?: boolean): GetCodesByCategoryAction {
  return {
    payload: { category, disabled },
    type: Types.GET_BY_CATEGORY,
  }
}

export function getCodesByCategorySuccess(data: Code[], category: Categories): GetCodesByCategorySuccessAction {
  return {
    payload: { category, data },
    type: Types.GET_BY_CATEGORY_SUCCESS,
  }
}

export function getCodesByCategoryFail(errors: object): GetCodesByCategoryFailAction {
  return {
    payload: { errors },
    type: Types.GET_BY_CATEGORY_FAIL,
  }
}
